'use strict';
import angular from 'angular';
import tritonFrequencyHtmlUrl from './views/tritonAds.frequency.html';

let app = angular.module('app.tritonAdsFrequencyComponent', []);

app.component('tritonAdsFrequency', {
    bindings: {
        showActions: '=',
        sets: '=',
        readOnly: '<'
    },
    templateUrl: tritonFrequencyHtmlUrl,

    // The controller that handles our component logic
    controller: function() {
        let self = this;
        self.unitTypes = ['hour', 'day', 'week', 'lifetime', 'break', 'download'];

        self.addNewSet = function() {
            if (self.sets.length < 5) {
                self.sets.push({
                    impressions: null,
                    durationUnits: null,
                    unitType: ''
                });
            }
        };

        self.clearKey = function(frequencyIndex) {
            self.sets.splice(frequencyIndex, 1);
        };

        self.initComponent = function() {
            if (self.sets && self.sets.length > 0) {
                if (typeof self.sets == 'string') {
                    self.sets = JSON.parse(self.sets);
                }
                if (self.showActions) {
                    self.showFrequencyView = false;
                    self.enableEditView = true;
                } else {
                    self.showFrequencyView = true;
                    self.enableEditView = false;
                }
            } else {
                self.sets = [{
                    impressions: null,
                    durationUnits: null,
                    unitType: ''
                }];
                self.showFrequencyView = false;
            }
        };

        self.validateFieldValues = function() {
            if (self.sets.unitType == 'hour' && !(self.sets.durationUnits >= 1 && self.sets.durationUnits <= 24)) {
                return 'hour: The length property must be between 1 and 24 (inclusive)';
            } else if (self.sets.unitType == 'day' && !(self.sets.durationUnits >= 1 && self.sets.durationUnits <= 28)) {
                return 'day: The length property must be between 1 and 28 (inclusive)';
            } else if (self.sets.unitType == 'week' && !(self.sets.durationUnits >= 1 && self.sets.durationUnits <= 4)) {
                return 'week: The length property must be between 1 and 4 (inclusive)';
            } else if ((self.sets.unitType == 'lifetime' || self.sets.unitType == 'break' || self.sets.unitType == 'download') && self.sets.durationUnits != 1) {
                return 'The length property must be set to 1';
            }
        };

        self.initComponent();
    }
});
